import React from "react";

interface ISliderProps {
  onChange: (name: string, value: number) => void;
  name: string;
  min: number;
  max: number;
  value: number;
  step: number;
}

export const Slider = (props: ISliderProps) => {
  const onSlide = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(props.name, event.target.valueAsNumber);
  }

  return (
  <div className="flex">
    <input type="range" min={props.min} max={props.max} value={props.value} onChange={onSlide} className="w-full mr-2" step={props.step} name={props.name} id={props.name}/>
    <span>{props.value}</span>
  </div>
  )
}